import { useLocation, useNavigate } from 'react-router-dom'

const useFilter = () => {
    // hooks
    const navigate = useNavigate()
    const location = useLocation()
    const { pathname, search } = location
    const paths = pathname.split('/').filter(Boolean)
    const queryParams = new URLSearchParams(search)

    const getSearchParam = key => {
        return queryParams.get(key)
    }

    const updateQueryParams = (params = {}) => {
        const { pathname } = location
        Object.entries(params).forEach(([key, value]) => {
            const prevValue = queryParams.get(key)

            // 빈 값이면 삭제
            if (value === '' || value == null) {
                queryParams.delete(key)
                return
            }

            // 이전값과 동일할 경우 토글 삭제 (예외 키 제외)
            if (prevValue === value && !['search', 'searchType', 'pageNo', 'startDate', 'endDate'].includes(key)) {
                queryParams.delete(key)
                return
            }

            // 기본적으로 세팅
            queryParams.set(key, value)
        })

        // 필터 변경 시 pageNo 제거 (단, 직접 pageNo 업데이트하는 경우 유지)
        if (!('pageNo' in params)) {
            queryParams.delete('pageNo')
        }

        const newQueryString = queryParams.toString()
        navigate(newQueryString ? `${pathname}?${newQueryString}` : pathname)
    }

    return {
        updateQueryParams,
        getSearchParam,
        queryParams,
        paths,
        pathname,
        search,
    }
}

export default useFilter
